export const formatTaskForUpload = ({
  data,
  tasks,
  uploadId,
  id,
  owner_id,
  session_ids
}) => {
  let toUpload = { ...data }

  // timeline task direct updates dont have access to parent id, need to fetch
  const pendingUpdateTask = tasks[uploadId]

  // Fix formatting on fields to match api
  const { primary = [], due_date, status, category, client } = toUpload

  const trimmedDate = new Date(due_date).toISOString()

  toUpload = {
    ...toUpload,
    assignee_ids: primary,
    due_date: trimmedDate,
    primary_assignee_id: primary[0] ?? null,
    status_id: status,
    category_id: category ?? tasks[id]?.category_id ?? null,
    concerning_user_id: client || tasks[id]?.concerning_user_id || null,
    owner_id: owner_id ?? null
  }

  delete toUpload.primary
  delete toUpload.date
  delete toUpload.status
  delete toUpload.priority
  delete toUpload.type
  delete toUpload.watchers
  delete toUpload.created_at
  delete toUpload.id

  toUpload = {
    ...toUpload,
    media_ids: data.media_ids ?? [],
    parent_id: pendingUpdateTask.parent_id ?? null,
    session_ids
  }

  return toUpload
}
